import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  pt32: {
    paddingTop: 32,
  },
}));

export default styles;
